<template>
  <div id="layout" style="height:100vh;" class="d-flex flex-column">
    <Navbar/>
    <router-view/>
  </div>
</template>

<script>
import Navbar from '../../components/Navbar'

export default {
  name: 'Layout',
  components: {Navbar}
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/Layout.vue